import { defineComponent, h } from 'vue';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';
import VerticalStack from '../VerticalStack.jsx';

export default defineComponent({
    name: 'replace-content-action-dsgn',
    components: {
        VerticalStack,
    },
    data: function () {
        return {
        }
    },
    computed: {
        Root: function () {
            return this.root;
        },
        Vars: function () {
            if (!this.controlData.Vars)
                this.controlData['Vars'] = {};

            return this.controlData.Vars;
        },
        DesignModel: function () {
            return this.designmodel;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        root: null,
        designmodel: null,
        parentType: '',
        controlData: {}
    },
    render() {
        const container = (
            <VerticalStack root={this.root} type={this.type} parentType="VerticalStack" designmodel={this.controlData.ControlData} controlData={this.controlData.ControlData}>
            </VerticalStack>
        );

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={{ margin: "5px", padding: "5px" }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                {container}
            </div>
        );
    }
});